import { styled, Typography } from "@mui/material";
import ColorPicker from "components/Input/ColorPicker";
import { StyledSelect as Select } from "components/Input/styled";
import { Field } from "formik";
import { createIncreamentArray } from "helpers/option";
import { StyledInputBase as InputBase } from "components/Input/styled";

const MarginChildContainer = styled("div")(({ theme }) => ({
  padding: "12px",
  display: "grid",
  gridTemplateColumns: "40% 60%",
  gridRowGap: "10px",
  // justifyContent: 'space-between'
}));

const MarginChildItemContainer = styled("div")(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(auto-fill, 45%)",
  gridGap: "2.5%",
  justifyContent: "space-between",
}));

const ElementContainer = styled("div")(({ theme }) => ({
  width: "100%",
  height: "70px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  width: "100%",
  height: "40px",
}));

const InputElement = ({ title }: { title: string }) => {
  return (
    <ElementContainer>
      <Typography variant="caption">{title}</Typography>
      <Field name={title} as={Select} />
    </ElementContainer>
  );
};

const TextChild = () => {
  const textSizeOption = createIncreamentArray(40);
  return (
    <MarginChildContainer>
      <Typography variant="caption" fontWeight="bold">
        عنوان ها
      </Typography>
      <MarginChildItemContainer>
        <ColorPicker title="رنگ" name="invoiceHeaderColor" />
        <ElementContainer>
          <Typography variant="caption">سایز</Typography>
          <Field name="invoiceHeaderSize" as={StyledInputBase} placeholder="px" type="number" />
        </ElementContainer>
      </MarginChildItemContainer>
      <Typography variant="caption" fontWeight="bold">
        متن ها
      </Typography>

      <MarginChildItemContainer>
        <ColorPicker title="رنگ" name="invoiceBodyColor" />
        <ElementContainer>
          <Typography variant="caption">سایز</Typography>
          <Field name="invoiceBodySize" as={StyledInputBase} placeholder="px" type="number" />
        </ElementContainer>
      </MarginChildItemContainer>
    </MarginChildContainer>
  );
};

export default TextChild;
